<template>
  <div class="container-xxl">
    <div class="row align-items-center">
      <div class="border-0">
        <div class="card-header py-1 no-bg bg-transparent d-flex align-items-center px-0 justify-content-between flex-wrap">
          
          </div>
        </div>
     
      </div>
      <div class="row clearfix g-3">
        <div class="col-lg-12">
          <div>
            <div>
              <div class="card mb-2">
                <div class="card-body p-0 mt-3 table-responsive">
                  <table  class="table table-hover align-middle mb-0 mis_table" style="width:100%">
                    <thead>
                      <tr>
                        
                        <th>
                          FullName</th>
                          
                        <th><div>AFM</div></th>
                        
                      </tr>
                    </thead>
                      <tbody>

                    <template v-for="user in users" :key="user.id">
  <tr>
    <td>                                                <router-link :to="{ path: 'under-recruitment-profile', query: { id: user.id } }">
{{ user.name }} {{ user.surname }}</router-link></td>
        <td>{{ user.afm }}</td>



  </tr>


</template>

                      <tr class="col" v-if="!users || !users.length">
                          <td colspan="100">No data</td>


                        </tr>
                    </tbody>
</table> 
                </div>
              </div>
            </div>
          </div>
        </div>                         
      </div>
    </div>

  </template>
  
  <script>
  import apiClient from '../services/api';
  import Select2 from 'vue3-select2-component';
  import { underRecruitment } from '@/services/followup';
    import { updateTotalDaysOff } from '@/services/employees';
  import { mapGetters } from 'vuex';
  import { ref, onMounted, computed } from 'vue';
import { useToast } from 'vue-toastification';

  export default {
    name: 'Days Off Reports',
    components: {
        Select2
    },
    computed: {
        ...mapGetters({
            getUserPermission: 'getUserPermission',
            getSuperUserPermission: 'getSuperUserPermission',

        }),
        superUser() {
            return this.getSuperUserPermission === 1;
        },
        userPermissions() {
            return this.getUserPermission('Days off reports');
        },
        canEditDayOff() {
            return this.userPermissions?.editCreator === 1;
        },
        canEditAllDaysOff() {
            return this.userPermissions?.editAll === 1;
        },
        canViewAllDaysOff() {
            return this.userPermissions?.viewAdmin === 1;
        },
        canCreateDayOff() {
            return this.userPermissions?.create === 1;
        },
        canArchive() {
            return this.userPermissions?.archive === 1;
        },
    },
    data() {
      return {
        filterYear: new Date().getFullYear(),
        filterMonth: '',
        select2Settings: {
              allowClear: true,
              placeholder: "Please select"
        },
        selectedUser: null,
        users: [],
        selectedManagerId: null,
       
        expandedMonth: null,
        selectedMonthData: null,
        editingUserId: null,
        editableDaysOff: null,

        years: [
          { value: (new Date().getFullYear() - 1), selected: '' },
          { value: new Date().getFullYear(), selected: 'selected="selected"' }
        ]
      };
    },
    methods: {
      startEditing(report) {
    this.editingUserId = report.userId;
    this.editableDaysOff = report.total_days_off_count;
  },

  // Cancel editing
  cancelEditing() {
    this.editingUserId = null;
    this.editableDaysOff = null;
  },

  // Submit updated value
  async submitTotalDaysOff(userId) {
    if (this.editableDaysOff === null || isNaN(this.editableDaysOff)) {
      alert('Παρακαλώ εισάγετε έναν έγκυρο αριθμό');
      return;
    }

    const payload = new FormData();
    payload.append('total_days_off', this.editableDaysOff);

    const response = await updateTotalDaysOff(payload, userId);

    const toast = useToast();


    if (response.data && response.data.success) {
       toast.success(response.data.message);

      this.cancelEditing();
      this.fetchData(); // Refresh the table
    } else {
       toast.error(response.data.message);
    }
  },

  formatDate(dateStr) {
  const date = new Date(dateStr);
  return date.toLocaleDateString('el-GR'); // π.χ. 02/01/2025
},

    
      fetchData() {
        apiClient.get('under-recruitment', {
          headers: {
            "Accept": "application/json",
            "Authorization": `Bearer ${localStorage.getItem('api_token')}`
          },
          
        })
        .then(response => {
         
          this.users = response.data.data;
          console.log(this.users)
        })
        .catch(error => {
          console.error(`status code: ${error.response.status}  jqXHR.responseText: ${error.response.data}`);
        });
      },
      doSearch() {
      this.fetchData();
    },
      updateManagerFilter(event) {
      this.selectedManagerId = event.target.value;
      this.doSearch();
    },
      applyServicesBindings() {
        $(document.body).on('click', '[data-selection-id]', function() {
          var selectionId = $(this).attr('data-selection-id');
          if ($(`[data-project-id-tasks="${selectionId}"]`).length > 1) {
            $(`[data-project-id-tasks="${selectionId}"]`).not('.reports_tasks_empty').each(function() {
              $(this).toggleClass('selectedRow');
              if ($(this).css('display') == 'none') {
                $(this).css('display', '');
              } else {
                $(this).css('display', 'none');
              }
            });
          } else {
            $(`[data-project-id-tasks="${selectionId}"]`).each(function() {
              $(this).toggleClass('selectedRow');
              if ($(this).css('display') == 'none') {
                $(this).css('display', '');
              } else {
                $(this).css('display', 'none');
              }
            });
          }
        });
  
        $(document.body).on('click', '.do-search', this.doSearch);
      }
    },
    async mounted() {
      this.applyServicesBindings();
      this.fetchData();
    }
  };
  </script>
  
  <style scoped>
  /* Add any component-specific styles here */
  </style>
  